// src/components/ProtectedRoute.tsx
import React, { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const [checked, setChecked] = useState(false);
  const [redirect, setRedirect] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const token =
      sessionStorage.getItem("access_token") ||
      localStorage.getItem("access_token");
    const hasPlan =
      sessionStorage.getItem("has_plan") ||
      localStorage.getItem("has_plan");

    if (!token) {
      const nextPath = `${location.pathname}${location.search}`;
      setRedirect(`/signup?next=${encodeURIComponent(nextPath)}`);
    } else {
      setRedirect(null);
    }
    // else if (hasPlan !== "true") {
    //   setRedirect("/pricing");
    // } else {
    //   setRedirect(null);
    // }

    setChecked(true);
  }, [location.pathname, location.search]); 

  // if (!checked) return <div>Loading...</div>;

  if (redirect) {
    return <Navigate to={redirect} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;


